export default "//yastatic.net/s3/distribution/pythia/frontend/_/18993321d65613758bc8f1b929e71ad1.png";